module.exports = __webpack_public_path__ + "static/img/pic_szh_zhptyy_gc_lb1@2x.0a6ea9e6.png";